module.exports = __webpack_public_path__ + "img/hr-artillery-wagon-cannon-barrel-7.e205f316.png";